import Splide from "@splidejs/splide";
import type {
  Options as SplideOptions,
  Splide as SplideSlider,
} from "@splidejs/splide";

export class ProductMediaSlider extends HTMLElement {
  private galleryConfig: SplideOptions;
  private galleryCarousel: SplideSlider | undefined;
  private thumbnailConfig: SplideOptions;
  private thumbnailCarousel: SplideSlider | undefined;
  private galleryElement: HTMLElement | undefined | null;
  private thumbnailElement: HTMLElement | undefined | null;

  constructor() {
    super();
    this.galleryConfig = {};
    this.galleryCarousel;
    this.thumbnailConfig = {};
    this.thumbnailCarousel;
  }

  connectedCallback() {
    this.setCarouselElements();
    this.initializeConfig();
    this.createCarousels();
  }

  createCarousels() {
    if (!this.galleryElement || !this.thumbnailElement) {
      return;
    }

    this.galleryCarousel = new Splide(this.galleryElement, this.galleryConfig);
    this.thumbnailCarousel = new Splide(
      this.thumbnailElement,
      this.thumbnailConfig,
    );
    this.galleryCarousel.sync(this.thumbnailCarousel);
    this.galleryCarousel.mount();
    this.thumbnailCarousel.mount();
  }

  setCarouselElements() {
    this.galleryElement = this.querySelector(
      '[js-product-media-slider="gallery"]',
    ) as HTMLElement | undefined;
    this.thumbnailElement = this.querySelector(
      '[js-product-media-slider="thumbnails"]',
    ) as HTMLElement | undefined;
  }

  moveToSlide(index: number): void {
    if (this.galleryCarousel) {
      this.galleryCarousel.go(index);
    }
  }

  initializeConfig(): void {
    this.galleryConfig = {
      autoplay: false,
      interval:
        parseInt(
          this.galleryElement?.getAttribute("setting-autoplay-speed") || "5",
        ) * 1000,
      pagination:
        this.galleryElement?.getAttribute("setting-pagination") === "true",
      arrows: this.galleryElement?.getAttribute("setting-arrows") === "true",
      perPage: 1,
      type: "loop",
      classes: {
        arrows:
          this.galleryElement?.getAttribute("setting-arrows") === "true"
            ? "uwp-carousel__arrows"
            : "",
        arrow:
          this.galleryElement?.getAttribute("setting-arrows") === "true"
            ? "uwp-carousel__arrow"
            : "",
        prev:
          this.galleryElement?.getAttribute("setting-arrows") === "true"
            ? "uwp-carousel__arrow--prev"
            : "",
        next:
          this.galleryElement?.getAttribute("setting-arrows") === "true"
            ? "uwp-carousel__arrow--next"
            : "",
      },
    };

    this.thumbnailConfig = {
      fixedWidth: 60,
      gap: 10,
      rewind: true,
      pagination: false,
      isNavigation: true,
      arrows: false,
    };
  }
}

export function moveToSlide(slider: ProductMediaSlider, index: number): void {
  slider.moveToSlide(index);
}

customElements.define("uwp-product-media-slider", ProductMediaSlider);
